import Vue from 'vue'
import VueRouter from 'vue-router'
//import Home from '../views/Home.vue'
import Main from '../views/Main.vue'
import Head from '../views/Head.vue'
import Search from '../views/Search.vue'
import Basket from '../views/Basket.vue'
import Orders from '../views/Orders.vue'
import order_info from '../views/order_info.vue'
import Promo from '../views/Promo.vue'
import Oth_Search from '../views/Oth_Search.vue'
import BasketOth from '../views/BasketOth.vue'
// import garantie from '../views/garantie.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    alias: '/main',
    name: 'Main',
    components: {
      head: Head,
      morph: Main,
    },
  },
  // {
  //   path: '/main',
  //   name: 'Main',
  //   components: {
  //     head: Head,
  //     morph: Main,
  //   },
  //   //props: { page }
  // },
  {
    path: '/search',
    name: 'Search',
    components: {
      head: Head,
      morph: Search,
    },
    //props: true
  },
  {
    path: '/basket',
    name: 'Basket',
    components: {
      head: Head,
      morph: Basket,
    },
  },
  {
    path: '/oth',
    name: 'Oth_Search',
    components: {
      head: Head,
      morph: Search,
    },
  },
  {
    path: '/basket_oth',
    name: 'BasketOth',
    components: {
      head: Head,
      morph: BasketOth,
    },
  },
  {
    path: '/orders',
    name: 'Orders',
    components: {
      head: Head,
      morph: Orders,
    },
    //props: true
  },
  {
    path: '/order_info/:orderId',
    name: 'order_info',
    components: {
      head: Head,
      morph: order_info,
    },
  },
  // {
  //   path: '/garantie',
  //   name: 'garantie',
  //   components: {
  //     head: Head,
  //     morph: garantie,
  //   },
  // },
  {
    path: '/promo',
    name: 'Promo',
    components: {
      head: Head,
      morph: Promo,
    },
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
